import React from 'react';
import { AiEnabledHeader } from '@atlassian/jira-minimizable-modal';
import { AiEnabledModalTitle } from '../ai-enabled-title';

export const AiEnabledMiniHeader = () => (
	<AiEnabledHeader data-testid="issue-create.common.ui.ai-enabled.ai-enabled-modal-mini-header.ai-enabled-mini-header">
		<AiEnabledModalTitle />
	</AiEnabledHeader>
);
